import { Box } from '@mui/material';
import { SCUIContent } from '@/atomic/organisms/SCUIContent/SCUIContent';

const getCargoReconciliationUrl = (): string => {
    const envName = (import.meta.env.VITE_ENVIRONMENT || '').toString().toLowerCase();

    if (envName === 'prod') {
        return 'https://kargomutabakat.lcwaikiki.com/Mutabakat';
    }

    return 'https://kargomutabakat-preprod.lcwaikiki.com/';
};

export const CargoReconciliationIFrame = () => {
    return (
        <SCUIContent>
            <Box
                sx={{
                    width: '100%',
                    height: '100%',
                    minHeight: 'calc(100vh - 160px)',
                    borderRadius: 2,
                    overflow: 'hidden',
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                }}
            >
                <Box
                    component="iframe"
                    title="Cargo Reconciliation"
                    src={getCargoReconciliationUrl()}
                    sx={{ width: '100%', height: '725px', border: 0 }}
                />
            </Box>
        </SCUIContent>
    );
};
